import classnames from "classnames";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { DEFAULT_LANGUAGE } from "../../../services/i18n";
import BalancePanel from "../../BalancePanel/BalancePanel";
import BonusPanel from "../../BonusPanel/BonusPanel";
import StatusBarButton from "../../StatusBarButton/StatusBarButton";
import StatusBarInfoBox from "../../StatusBarInfoBox/StatusBarInfoBox";

// tslint:disable-next-line:no-var-requires
const style = require("./LoggedInStatusBar.scss");

interface LoggedInStatusBarProps {
    readonly userApproved: boolean;
    readonly balance: number;
    readonly userLogin: string;
    readonly bonusValue: string;
    readonly currency: string;
    readonly hasOptInCheckboxChecked: boolean;
    readonly foreignLogin: boolean;
    readonly validForeignUser: boolean;
    readonly onLogout: () => void;
}

const SMALL_FONT_LANGUAGES = ["tr", "el", "fr", "es", "hr"];

export class LoggedInStatusBar extends React.Component<
    LoggedInStatusBarProps & WithTranslation,
    {}
> {
    constructor(props: LoggedInStatusBarProps & WithTranslation) {
        super(props);
    }

    public render() {
        const {
            t,
            userApproved,
            balance,
            bonusValue,
            currency,
            userLogin,
            foreignLogin,
            onLogout
        } = this.props;
        const wrapperClass = classnames(
            style.statusBar,
            this.useSmallFont() && style.smallFonts
        );

        const accountRoute = this.props.validForeignUser
            ? "/account-overview"
            : "/account";
        return (
            <div className={wrapperClass}>
                <StatusBarButton
                    className={classnames(style.logout)}
                    onClick={onLogout}
                >
                    {t("Logout")}
                </StatusBarButton>
                <Link to={accountRoute}>
                    <StatusBarButton
                        className={classnames(style.account)}
                        disabled={!userApproved}
                    >
                        {t("Account")}
                    </StatusBarButton>
                </Link>
                <BalancePanel
                    anonymous={false}
                    balance={balance}
                    balanceHiddenText={t("Balance label")}
                    balanceTextFormat={this.formatBalance}
                    currency={currency}
                    userLogin={userLogin}
                    foreignLogin={foreignLogin}
                    className={classnames(style.balancePanel)}
                />
                <StatusBarInfoBox>{userLogin}</StatusBarInfoBox>
                <BonusPanel
                    className={classnames(style.bonus)}
                    bonusValue={bonusValue}
                    formatBonus={this.formatBonus}
                />
            </div>
        );
    }

    private useSmallFont() {
        return SMALL_FONT_LANGUAGES.includes(
            this.props.i18n.language || DEFAULT_LANGUAGE
        );
    }

    private formatBalance = (balance: number) => {
        const t = this.props.t;

        if (this.props.foreignLogin) {
            return t("Not available");
        } else {
            return t("Balance", {
                balance: balance.toFixed(2),
                currency: this.props.currency
            });
        }
    };

    private formatBonus = (bonus: string) => this.props.t("Bonus", { bonus });
}

export default withTranslation("loggedInStatusBar")(LoggedInStatusBar);
